import 'css-chunk:src/cms/iconHighlight/iconHighlight.module.scss';export default {
  "heading-xxl": "iconHighlight-module__heading-xxl___RhvQu",
  "wrapper": "iconHighlight-module__wrapper___qbrvm",
  "heading-xl": "iconHighlight-module__heading-xl___P1aO2",
  "heading-lg": "iconHighlight-module__heading-lg___GMKs4",
  "heading-md": "iconHighlight-module__heading-md___wm-6I",
  "heading-sm": "iconHighlight-module__heading-sm___5-1EP",
  "heading-xs": "iconHighlight-module__heading-xs___XtqGR",
  "body-one": "iconHighlight-module__body-one___zJzV5",
  "body-two": "iconHighlight-module__body-two___ly-x6",
  "body-three": "iconHighlight-module__body-three___NiLrP",
  "body-four": "iconHighlight-module__body-four___89S-k",
  "overline-one": "iconHighlight-module__overline-one___zUdpd",
  "overline-two": "iconHighlight-module__overline-two___Mctvy",
  "overline-three": "iconHighlight-module__overline-three___RRuqd",
  "strong": "iconHighlight-module__strong___pgv55",
  "em": "iconHighlight-module__em___5wY4q",
  "figcaption": "iconHighlight-module__figcaption___O6xtG",
  "no-margin": "iconHighlight-module__no-margin___YZcbu",
  "iconHighlight": "iconHighlight-module__iconHighlight___az-7D",
  "iconHighlightIcon": "iconHighlight-module__iconHighlightIcon___nhvTu",
  "iconHighlightText": "iconHighlight-module__iconHighlightText___JOwRI",
  "iconHighlightLinkList": "iconHighlight-module__iconHighlightLinkList___Gtuk5",
  "iconHighlightLink": "iconHighlight-module__iconHighlightLink___-ArVD"
};